import React from 'react'
import MainComponent from 'src/Libs/shop/components/SystemConfiguration/MainComponent'
import { useQntmSystemConfigurationContext } from 'src/Libs/shop/context/use-shop-qntm-system-configuration-context'
import { useShopQntmMainComponent } from '../hooks/use-shop-qntm-main-component'

/*
 * Wrapper for Main Component step connecting hook data with configurator context
 */
const QntmMainComponent: React.FC = () => {
  const { setAllowContinueMain } = useQntmSystemConfigurationContext()
  const { title, categories, isLoading, qntmProduct, onBack, onMoreInfo, onSelectProduct, isProductSelected, canContinue } =
    useShopQntmMainComponent()

  return (
    <MainComponent
      title={title}
      categories={categories}
      qntmProduct={qntmProduct}
      isLoading={isLoading}
      onBack={onBack}
      onMoreInfo={onMoreInfo}
      onSelectProduct={onSelectProduct}
      isProductSelected={isProductSelected}
      canContinue={canContinue}
      onAllowContinueChange={setAllowContinueMain}
    />
  )
}

export default QntmMainComponent
